import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable learning-center-ui/no-i18n-component-imports */
import { useContext } from 'react';
import * as React from 'react'; // @ts-expect-error Could not find a declaration file for module

import LocaleContext from '../contexts/LocaleContext';
import I18nFormattedMessage from 'I18n/components/FormattedMessage';
import I18nFormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18nFormattedReactMessage from 'I18n/components/FormattedReactMessage';
import I18nFormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import I18nFormattedList from 'I18n/components/FormattedList';
import I18nFormattedName from 'I18n/components/FormattedName';
import I18nFormattedNumber from 'I18n/components/FormattedNumber';
import I18nFormattedCurrency from 'I18n/components/FormattedCurrency';
import I18nFormattedPercentage from 'I18n/components/FormattedPercentage';
import I18nFormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import I18nFormattedSize from 'I18n/components/FormattedSize';
import I18nFormattedFraction from 'I18n/components/FormattedFraction';
import I18nFormattedDateTime from 'I18n/components/FormattedDateTime'; // @ts-expect-error Could not find a declaration file for module

import I18nFormattedDuration from 'I18n/components/FormattedDuration';

const withLocale = Component => (_ref) => {
  let {
    options = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["options"]);

  const {
    locale
  } = useContext(LocaleContext);
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    options: Object.assign({}, options, {
      locale: locale === 'pt' ? 'pt-br' : locale === 'no' ? 'no-no' : locale
    })
  }));
};

export const FormattedMessage = withLocale(I18nFormattedMessage);
export const FormattedHTMLMessage = withLocale(I18nFormattedHTMLMessage);
export const FormattedReactMessage = withLocale(I18nFormattedReactMessage);
export const FormattedJSXMessage = withLocale(I18nFormattedJSXMessage);
export const FormattedList = withLocale(I18nFormattedList);
export const FormattedName = withLocale(I18nFormattedName);
export const FormattedNumber = withLocale(I18nFormattedNumber);
export const FormattedCurrency = withLocale(I18nFormattedCurrency);
export const FormattedPercentage = withLocale(I18nFormattedPercentage);
export const FormattedPhoneNumber = withLocale(I18nFormattedPhoneNumber);
export const FormattedSize = withLocale(I18nFormattedSize);
export const FormattedFraction = withLocale(I18nFormattedFraction);
export const FormattedDateTime = withLocale(I18nFormattedDateTime);
/**
 * FormattedDuration doesn't have types defined so these are defined here as a stop gap
 */

export const FormattedDuration = withLocale(I18nFormattedDuration);